import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  OnDestroy,
  Input,
} from '@angular/core';
import { Subject } from 'rxjs';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Store, select } from '@ngrx/store';
import { ApplicationState } from 'src/app/modules/acbcr/common/state/app.state';
import { getCurrentRoute } from 'src/app/modules/acbcr/common/state/reducers/route.reducers';
import { takeUntil } from 'rxjs/operators';
import { getSelectedHolding } from 'src/app/modules/acbcr/common/state/reducers/holdings.reducers';

@Component({
  selector: 'app-certificat-list-search',
  templateUrl: './certificatlist-search.component.html',
  styleUrls: ['./certificatlist-search.component.scss']
})
export class CertificatListSearchComponent implements OnInit, OnDestroy {
  @Input() isFermier;
  @Output() searchResult = new EventEmitter();
  certificatListSearchForm;
  destroy$: Subject<boolean> = new Subject<boolean>();
  currentRoute;
  exploatatieName;
  exploatatieCode;
  isOnHolding = false;

  constructor(
    private store: Store<ApplicationState>
  ) { }

  ngOnInit(): void {
    this.store.pipe(select(getSelectedHolding))
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: any) => {
        if (response) {
          this.exploatatieName = response.name;
          this.exploatatieCode = response.code;
        }
      });

    this.store.pipe(select(getCurrentRoute))
    .pipe(takeUntil(this.destroy$))
    .subscribe((response: string) => {
      this.currentRoute = response;
    });

    this.isOnHolding = this.currentRoute.includes('/dashboard/certificate-zootehnice') ? false : true;

    this.certificatListSearchForm = new UntypedFormGroup({
      company_name: new UntypedFormControl(this.isOnHolding ? this.exploatatieName : null),
      company_code: new UntypedFormControl(this.isOnHolding ? this.exploatatieCode : null),
      numarmatricol: new UntypedFormControl(null)
    });

    if (this.isOnHolding) {
      this.certificatListSearchForm.controls.company_name.disable();
      this.certificatListSearchForm.controls.company_code.disable();
    }
  }

  onSubmitted() {
    this.searchResult.emit(this.certificatListSearchForm.value);
  }

  resetSearch() {
    this.certificatListSearchForm.reset();
    this.onSubmitted();
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.unsubscribe();
  }

}
